import { RecurringInvoiceContract } from "../domain/RecurringInvoiceContract";
import { RecurringInvoiceListScreenData } from "../domain/RecurringInvoiceListScreenData";

const headers_invoice = [

    {
        text: "Id",
        sortable: true,
        value: "id",
    },
    {
        text: "Estado",
        sortable: false,
        value: "state",
    },
    {
        text: "Fecha de inicio",
        sortable: true,
        value: "start_date",
    },
    {
        text: "Fecha de fin",
        sortable: true,
        value: "end_date",
    },
    {
        text: "Intervalo",
        sortable: false,
        value: "interval",
    },
    {
        text: "Periodo",
        sortable: false,
        value: "period",
    },
    {
        text: "Nombre del cliente",
        sortable: false,
        value: "customer_name",
    },
    {
        text: "Importe total",
        sortable: false,
        value: "total_amount",
    }
]


export class VueRecurringInvoiceListScreenData implements RecurringInvoiceListScreenData{
    recurringInvoices: RecurringInvoiceContract[];
    recurringInvoicesHeaders: Object;
    selectedItems: Array<RecurringInvoiceContract>;
    loadingItems: boolean;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Object;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    hideHeaderCheckbox: boolean;
    mobile: boolean;
    totalItems: Number;
    sort_by: string;
    limit: Number;
    offset: Number;
    snackbar: Object;
    actionMenu: boolean;
    deletePopup: boolean;
    availableFilters: Object;
    excelPopup: boolean;
    file: File;
    adjustPricePercentPopup: boolean;
    adjustPricePercent: Number;
    adjustPriceFixedPopup: boolean;
    adjustPriceFixed: Number;
    resolvePopup: Function;
    forceGeneratePopup: boolean;
    hasActiveContract: boolean;

    constructor(){
        this.recurringInvoices = []
        this.recurringInvoicesHeaders = headers_invoice
        this.selectedItems = []
        this.loadingItems = false
        this.footerItemsPerPageText = 'Facturas por página'
        this.footerItemsPerPageOptions = [5, 10, 50]
        this.showSelect = true
        this.textNoResults = 'No se encontraron resultados'
        this.textLoading = 'Cargando...'
        this.itemKey = 'id'
        this.hideHeaderCheckbox = false
        this.mobile = true
        this.totalItems = 0
        this.sort_by = 'id'
        this.limit = 10
        this.offset = 0
        this.snackbar = {
            ['isVisible']: false,
            text: '',
            color: '',
            timeout: 3000,
        }
        this.actionMenu = false
        this.deletePopup = false
        this.excelPopup = false
        this.file = null
        this.adjustPricePercentPopup = false
        this.adjustPricePercent = null
        this.adjustPriceFixedPopup = false
        this.adjustPriceFixed = null
        this.forceGeneratePopup = false
        this.hasActiveContract = false
        this.availableFilters = {
            state: {
                'name': 'state',
                'label': 'Estado',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'not_started', text: 'No comenzado'},
                    { value: 'started', text: 'En curso'},
                    { value: 'finished', text: 'Finalizado'},
                    { value: 'stopped', text: 'Detenido'},
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            start_date_from: {
                'name': 'start_date_from',
                'label': 'Fecha inicio desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            start_date_to: {
                'name': 'start_date_to',
                'label': 'Fecha inicio hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            end_date_from: {
                'name': 'end_date_from',
                'label': 'Fecha fin desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            end_date_to: {
                'name': 'end_date_to',
                'label': 'Fecha fin hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            interval: {
                'name': 'interval',
                'label': 'Intervalo',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'mensual', text: 'Mensual'},
                    { value: 'trimestral', text: 'Trimestral'},
                    { value: 'anual', text: 'Anual'},
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            period: {
                'name': 'period',
                'label': 'Periodo',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'adelantado', text: 'Adelantado'},
                    { value: 'atrasado', text: 'Atrasado'},
                ],
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-document',
                'text': '',
            },
            info_third: {
                'name': 'info_third',
                'label': 'Datos del cliente',
                'value': '',
                'type': 'text',
                'icon': 'mdi-card-account-details',
            },
            total_amount: {
                'name': 'total_amount',
                'label': 'Importe total',
                'value': 0,
                'type': 'number',
                'icon': 'mdi-numeric',
            },
        }
    }

    setRecurringInvoices(recurringInvoices: RecurringInvoiceContract[]): void {
        this.recurringInvoices = recurringInvoices
    }

    setTotalItems(totalItems: Number): void {
        this.totalItems = totalItems
    }

    setLoading(loading: boolean): void {
        this.loadingItems = loading
    }

    successMessage(message){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    errorMessage(message ) {
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    async askForFile(): Promise<unknown> {
        this.excelPopup = true
        return new Promise((resolve, reject) => {
            this.resolvePopup = resolve
        })
    }

    confirmPopup(): void {
        this.excelPopup = false
        this.resolvePopup(true)
    }

    cancelPopup(): void {
        this.excelPopup = false
        this.resolvePopup(false)
    }
}
